import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { Feriado } from 'src/app/core/feriado';
import { DataUtilService } from '../../../services/commons/data-util.service';
import { FeriadoService } from './../../../services/feriado/feriado.service';
import { ToastService } from './../../../services/toast/toast.service';

@Component({
    selector: 'app-cadastrar-feriado',
    templateUrl: './cadastrar-feriado.component.html',
    styleUrls: ['./cadastrar-feriado.component.css']
})
export class CadastrarFeriadoComponent implements OnInit {

    feriado: Feriado;

    isAtualizar: boolean = false;

    perfilAcesso: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();

    mostrarBotaoCadastrar = true
    mostrarBotaoAtualizar = true;

    constructor(private feriadoService: FeriadoService,
                private activatedRoute: ActivatedRoute,
                private toastService: ToastService,
                private router: Router, private dataUtilService: DataUtilService) {
    }

    ngOnInit() {
        this.inicializarObjetos();

        this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

        if (!this.perfilAcesso.insere)
            this.mostrarBotaoCadastrar = false;

        if (!this.perfilAcesso.altera)
            this.mostrarBotaoAtualizar = false;

        let id: number;
        id = this.activatedRoute.snapshot.queryParams.id ? this.activatedRoute.snapshot.queryParams.id : null;
        if (id) {
            this.isAtualizar = true;
            this.feriadoService.getById(id).subscribe((feriado: Feriado) => {
                this.feriado = feriado
            });
        }

    }

    inicializarObjetos() {
        this.feriado = new Feriado();
    }

    cadastrar() {
        this.feriadoService.cadastrar(this.feriado).subscribe(() => {
            this.router.navigate(['feriado']);
            this.toastService.showSucesso("Feriado cadastrado com sucesso");
        });
    }

    mostrarBotaoLimpar() {
        if (this.isAtualizar) return false;
        if (!this.mostrarBotaoAtualizar) return false;
        if (!this.mostrarBotaoCadastrar) return false;

        return true;
    }

    limpar() {
        this.inicializarObjetos();
    }

    cancelar() {
        this.router.navigate(['feriado']);
    }

    atualizar() {
        this.feriadoService.alterar(this.feriado).subscribe(() => {
            this.router.navigate(['feriado']);
            this.toastService.showSucesso("Feriado atualizada com sucesso");
        });

    }

    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }
}
